import { ReactComponent as IconSvg } from 'approot/shared/inline-svg/activity-builder/icon_circle.svg';
import Icon, { IconProps } from '../../icons/icon';

const IconCircle = (props: IconProps) => {
  return <Icon {...props} Svg={IconSvg} />;
};

export default IconCircle;
